<template>
    <v-col cols="12" sm="auto" md="auto" style="cursor:pointer;">
        <v-card class="kicker"
                v-scroll-to="'#funding'"
                elevation="4"
                color="green darken-4"
                dark>
            <div style="float:right;" class="ma-0 mt-2 mr-1">
                <span v-if="!HasFEEnrolments || HasHNEnrolments" class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-info"></i>
                    <i class="fas fa-info fa-stack-1x"></i>
                </span>
                <span v-else-if="HasUnstartedBursaryApplications" class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-error"></i>
                    <i class="fas fa-exclamation fa-stack-1x"></i>
                </span>
                <span v-else-if="HasUnsubmittedBursaryApplications" class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-warning"></i>
                    <i class="fas fa-exclamation fa-stack-1x"></i>
                </span>
                <span v-else-if="HasBeingProcessedBursaryApplications" class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-info"></i>
                    <i class="fas fa-info fa-stack-1x"></i>
                </span>
                <span v-else class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-success"></i>
                    <i class="fas fa-check fa-stack-1x"></i>
                </span>
            </div>
            <v-card-title>Your Funding</v-card-title>
            <v-card-text>
                <p v-if="!HasFEEnrolments || HasHNEnrolments" class="ma-0">View your funding options</p>
                <p v-else-if="HasUnstartedBursaryApplications" class="ma-0">Begin your funding application</p>
                <p v-else-if="HasUnsubmittedBursaryApplications" class="ma-0">Continue your funding application</p>
                <p v-else-if="HasBeingProcessedBursaryApplications" class="ma-0">Your funding application is being processed</p>
                <p v-else class="ma-0">View the status of your funding application</p>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'

    export default {
        props: ['enrolments', 'bursaryApplications'],
        mixins: [enrolmentsMixin],
        computed: {
            FEBursaryApplications() { return this.bursaryApplications.filter(ba => this.FEEnrolments.filter(e => e.EnrolmentID == ba.EnrolmentID)); },
            HasUnstartedBursaryApplications() {
                return this.FEBursaryApplications.length == 0 || this.FEBursaryApplications.filter(ba => ba.ApplicationStatusCode == null).length > 0;
            },
            HasUnsubmittedBursaryApplications() {
                return this.FEBursaryApplications.length > 0 && this.FEBursaryApplications.filter(ba => ['UNSUB', 'DC'].includes(ba.ApplicationStatusCode) === true).length > 0;
            },
            HasBeingProcessedBursaryApplications() {
                return this.FEBursaryApplications.length > 0 && this.FEBursaryApplications.filter(ba => ['SUB'].includes(ba.ApplicationStatusCode) === true).length > 0;
            },
        },
    }
</script>
